import React from 'react';

import Share from 'src/components/MetaButtons/Share/Share';

import * as customStyled from './styles';

const ShareButtonMedium: React.FC<any> = ({
  shareItems,
  fromThumbnail,
  fromCarousel = false,
  isSportsLiveEvent = false,
  isReferralURL = false,
  cardDetails,
  detailsPageFlag
}) => {
  return (
    <div css={customStyled.container}>
      <Share
        item={shareItems}
        fromThumbnail={fromThumbnail}
        fromCarousel={fromCarousel}
        cardDetails={cardDetails}
        detailsPageFlag={detailsPageFlag}
        isSportsLiveEvent={isSportsLiveEvent}
        isReferralURL={isReferralURL}
      />
    </div>
  );
};

export default ShareButtonMedium;
